
import { Component, Vue } from 'vue-property-decorator';
import { setJwtToken } from '@momnt-technologies/common-ui/lib/api/utils';
import { appLogin } from '@/api/auth';
import Alert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import EmailInput from '~/components/Inputs/Email.vue';
import PasswordInput from '@/components/common/Inputs/Password.vue';
import ResetPasswordDialog from '@/components/common/Dialogs/ResetPasswordDialog.vue';
import { getNonFieldError } from '@/utils/error-handler';

@Component({
  components: {
    Alert,
    CustomButton,
    EmailInput,
    PasswordInput
  }
})
export default class AppLogin extends Vue {
  email = '';

  password = '';

  errorMessage = '';

  loading = false;

  async login() {
    this.loading = true;
    try {
      const { data } = await appLogin({
        email: this.email,
        password: this.password
      });
      setJwtToken(data.token);
      this.$router.push({ name: 'home' });
    } catch (error) {
      this.errorMessage = getNonFieldError(error);
      this.loading = false;
    }
  }

  resetPassword() {
    this.$dialog({ component: ResetPasswordDialog });
  }
}
